{
  "timeValidationError": "O minuto deve ser de 00 a 59",
  "startEndTimeValidationError": "O horário de término deve ser após o horário de início",
  "Eq": "Iguais",
  "Gt": "Maior que",
  "Gte": "Maior ou igual a",
  "Lt": "Menos que",
  "Lte": "Menor ou igual a",
  "Ct": "Contém",
  "deleteRow": "Excluir linha",
  "addRow": "Adicionar nova linha",
  "addColumn": "Adicionar coluna",
  "deleteAll": "Excluir tudo",
  "uploadData": "Carregar dados",
  "deleteExisting": "Excluir itens existentes",
  "keepExisting": "Mantenha os itens existentes",
  "downloadData": "Baixar dados",
  "schedule": {
    "day": "Dia",
    "date": "Data",
    "start": "Iniciar",
    "end": "Fim",
    "duration": "Duração (minutos)",
    "venue": "Local",
    "space": "Espaço",
    "type": "Tipo",
    "Discipline": "Discipl",
    "zero": "Zero",
    "description": "Descrição"
  },
  "toasts": {
    "edit_success": "Célula editada com sucesso",
    "edit_error": "Erro ao editar a célula, considere atualizar as células",
    "insert_success": "Adicionado com sucesso {{ type }}",
    "insert_error": "Erro ao inserir a linha, considere atualizar as células",
    "delete_success": "Entidade de linha excluída com sucesso",
    "delete_error": "Erro ao excluir a linha, considere atualizar as células",
    "refresh_cells": "Atualizar células"
  },
  "dataTable": {
    "filter": {
      "equals": "Iguais",
      "greaterThan": "Maior que",
      "greaterThanOrEqualTo": "Maior ou igual a",
      "lessThan": "Menos que",
      "lessThanOrEqualTo": "Menor ou igual a",
      "contains": "Contém",
      "select_all": "Selecionar tudo"
    }
  },
  "type_something": "Digite {{ name }}",
  "group": "Grupo",
  "count_column_header": "(Contagem)",
  "none_group": "Nenhum",
  "Export selected rows only": "Exportar somente linhas selecionadas",
  "Export all": "Exportar tudo",
  "from": "De",
  "to": "Para"
}